import {
  filterObjectByCondition,
  getPaymentInfo,
} from "@lib/utilities/HelperFunctions";

// to exract the decimal value
// to-do needs to re-evaluate
export function unwrapDecimal(value: any): number | null {
  if (!isNaN(value)) return value;

  if (!isNaN(value.$numberDecimal)) return parseFloat(value.$numberDecimal);

  if (!isNaN(value.$decimal)) return value.$decimal;

  if (!isNaN(value?.$decimal?.$numberDecimal))
    return parseFloat(value.$decimal.$numberDecimal);

  return null;
}

export const toPolicyListingModal = (policy: any) => ({
  physicalAddress: policy.physicalAddress,
  product: policy.product,
  policyNumber: policy.policyNumber,
  policyStatus: policy.policyStatus,
  effectiveDate: policy.effectiveDate,
});

export const toPoliciesModal = (policies: any) =>
  policies.map((policy: any) => toPolicyListingModal(policy));

const normalizeBillingDetails = (billingDetails: any): any => {
  const normalize = (obj: any): any => {
    if (typeof obj !== "object" || obj === null) return obj;
    const result: any = {};
    for (const key in obj) {
      const value = obj[key];
      if (value && typeof value === "object" && "value" in value) {
        // Handle type-specific normalization
        let normalizedValue;
        if (value.type === "decimal" || value.format === "currency") {
          normalizedValue = unwrapDecimal(value.value);
        } else if (value.type === "date" || value.format === "date") {
          normalizedValue = value?.value.hasOwnProperty("$date")
            ? value?.value?.["$date"] ?? ""
            : value?.value ?? "";
        } else {
          normalizedValue = value.value;
        }
        result[key] = {
          ...value,
          value: normalizedValue,
        };
      } else if (typeof value === "object" && value !== null) {
        result[key] = normalize(value);
      } else {
        result[key] = value;
      }
    }

    return result;
  };

  const normalized = normalize(billingDetails);

  if (
    normalized?.information?.nextPayment?.value != null ||
    normalized.premium.balanceDue?.value != null
  ) {
    const amount = getPaymentInfo(
      normalized.information?.nextPayment.value,
      normalized.premium.balanceDue?.value,
    );
    normalized.premium.isDue = Number(amount) > 0;
  }
  return normalized;
};
const normalizeCoverageDetails = (coverageDetails: any) => {
  return {
    coverageLimits: coverageDetails?.coverageLimits,
    coverageOptions: coverageDetails?.coverageOptions,
    deductibles: filterObjectByCondition(
      coverageDetails?.deductibles,
      (item) => item.visible !== false,
    ),
    surcharges: coverageDetails?.surcharges,
    underwritingAnswers: coverageDetails?.underwritingAnswers,
    combinedCoverages: {
      ...coverageDetails.coverageLimits,
      ...filterObjectByCondition(
        coverageDetails.coverageOptions,
        (item) => item.visible,
      ),
    },
  };
};

export const keyToTitle = (str: String) =>
  str.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());

export const toPolicyDetail = (policy: any) => ({
  policyNumber: policy.policyNumber,
  companyCode: policy.companyCode,
  state: policy.state,
  product: policy.product,
  policyStatus: policy.policyStatus,
  effectiveDate: policy.effectiveDate,
  endDate: policy.endDate,
  mailingAddress: policy?.mailingAddress,
  policyHolders: policy.policyHolders,
  propertyDetails: policy.propertyDetails,

  // billingDetails:
  billingDetails: normalizeBillingDetails({
    ...policy.billingDetails,
    information: {
      ...policy.billingDetails.information,
      effectiveDate: {
        value: policy.effectiveDate,
        displayText: keyToTitle("policyEffectiveDate"),
        type: "date",
        format: "date",
      },
    },
  }),
  // coverageDetails:
  coverageDetails: normalizeCoverageDetails(policy.coverageDetails),

  agent: {
    primaryPhoneNumber: policy?.agent?.primaryPhoneNumber,
    emailAddress: policy?.agent?.emailAddress,
    faxNumber: policy?.agent?.faxNumber,
    firstName: policy?.agent?.firstName,
    lastName: policy?.agent?.lastName,
    physicalAddress: policy?.agent?.physicalAddress,
    mailingAddress: policy?.agent?.mailingAddress,
    errorCode: policy?.agent?.errorCode,
    agencyName: policy?.agency?.displayName,
    agencyCode: policy?.agency?.agencyCode,
  },
  enabledPayment: policy?.enabledPayment,
});
